import React, { Component } from "react";
import { Link } from "react-router-dom";

class CancelButton extends Component {
  render() {
    const { onClick, label, path, classes } = this.props;

    return path ? (
      <Link to={`${path}`}>
        <span className={`p-btn p-btn-grey`}>{label}</span>
      </Link>
    ) : (
      <span className={`p-btn p-btn-grey  ${classes}`} onClick={onClick}>
        {label}
      </span>
    );
  }
}

export default CancelButton;



// WEBPACK FOOTER //
// src/components/buttons/CancelButton.js